 export default function paginationHelper (listPageNum, listPerPage, total) {
     const start = ((listPageNum - 1) * listPerPage) + 1
     const end = Math.min(listPageNum * listPerPage, total)
     if (end !== undefined && end !== 0) return `${start} - ${end} of ${total}`
     return ''
 }
